import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navItems } from "@/mocks/site";

interface SiteHeaderProps {
  overlay?: boolean;
}

const SiteHeader = ({ overlay = false }: SiteHeaderProps) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = !overlay || scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 group">
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md text-lg ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
              }`}
            >
              <i className="ri-folder-shield-2-line" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-bold text-base md:text-lg tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                塌房档案局
              </span>
              <span
                className={`hidden sm:block text-[11px] mt-1 ${
                  solid ? "text-foreground-500" : "text-background-200"
                }`}
              >
                吃瓜不迷路
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => {
              const active =
                item.href === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.href);
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    active
                      ? "text-primary-600 bg-primary-100/70"
                      : solid
                        ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                        : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/about#submit"
              className="ml-3 px-4 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              我要爆料
            </Link>
          </nav>

          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="px-4 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about#submit"
              className="mt-1 px-4 py-3 rounded-md text-sm font-medium text-center bg-primary-500 text-background-50"
            >
              我要爆料
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;